define('app',[
	'marionette',
	'has',
	'spin',
	'models/shared/session',
	'views/user/login/login',
	'models/shared/user/role',
	'models/shared/user/role_collection',
	//'vendors/es6-promise/es6-promise'
	'deepmerge'
], function(Marionette, has, Spinner, Session, LoginView, Role, Roles, Merge){
	'use strict';

	extendLib();

	var app = new Marionette.Application();
	
	app.local = false;
	app.envName = '';
	var host = window.location.host,
		href = window.location.href;

	// Function added by BC to eliminate verbousity. As more local dev environments are added, just add them to the array. This may be useful within the APP at other points.
	app.isLocalHost = function(){
		var hosts = ['localhost','davidforsythe.local','pfcadmins-macbook-pro-3.local', 'davids-macbook-pro.local'],
			hostsLength = hosts.length;
		for(var i = 0; i < hostsLength; i++){
			if(host.indexOf(hosts[i]) >= 0){
				return true;
			}
		}
		return false;
	};

	// Check if environment supports native promises
	if(typeof Promise === 'undefined'){
		//var Promise = require(es6Promise).Promise;
	}
	
	if(!app.local || has('prodBuild')){
		var protocol = 'https:';
		var buildType = '';
		var agapibuildType = '';

		app.imagePath = 'images.payforward.com';

		if (host.startsWith('dev')) {
			buildType = 'dev';
			agapibuildType = 'dev';
			app.imagePath = 'devimages.payforward.com';
			app.envName = 'Development';

			//setupCognitoEnvironment(app, true);
			setupCookieEnvironment(host, true);
		} else if (host.startsWith('qa')) {
			buildType = 'qa';
			agapibuildType = 'qa';
			app.imagePath = 'qaimages.payforward.com';
			app.envName = 'QA';

			//setupCognitoEnvironment(app, true);
			setupCookieEnvironment(host, true);
		} else if (host.startsWith('stage')) {
			buildType = 'stage';
			agapibuildType = '';
			app.imagePath = 'images.payforward.com';
			app.envName = 'Stage';

			//setupCognitoEnvironment(app, false);
			setupCookieEnvironment(host, true);
		} else if (app.isLocalHost()) {
			buildType = 'dev';
			agapibuildType = 'dev';
			app.imagePath = 'devimages.payforward.com';
			app.envName = 'Development';

			//setupCognitoEnvironment(app, true);
			setupCookieEnvironment();
		} else {
			buildType = 'private';
			agapibuildType = '';
			//setupCognitoEnvironment(app, true);
			setupCookieEnvironment(host, true);

			//if (host.indexOf('anthem') < 0 && host.indexOf('dev') == -1) {
			//    var l = document.createElement('a');
			//    l.href = window.location;
			//    var url = 'https://anthem.payforward.com/' + l.hash;
			//    window.location.replace(url);
			//}
		}

		app.awsUrl = protocol + '//' + buildType + 'service.payforward.com/v1';
		app.awsSearchUrl = protocol + '//' + buildType + 'service.payforward.com/v1/search';
		app.url = protocol + '//' + buildType + 'api.payforward.com';
		app.agapi = protocol + '//' + agapibuildType + 'agapi.payforward.com';
		app.authURL = app.url + '/Auth';
		app.userURL = app.url + '/User';
		app.consumerURL = app.url + '/Consumer';
		app.accountsURL = app.url + '/Accounts';
		app.merchantsURL = app.url + '/Merchant';
		app.merchantsSearchURL = app.awsSearchUrl + '/merchants';
		app.helperURL = app.url + '/Helper';
		app.lookupsURL = app.url + '/Lookups';
		app.searchURL = app.url + '/Search';
		app.searchSuggestionURL = app.awsSearchUrl + '/merchants/suggesters';
		app.searchCitySuggestionURL = app.awsSearchUrl + '/citystate';
		app.sharedURL = app.url + '/Shared';
		app.personalmessageURL = app.url + '/PersonalMessages';
		app.imageURL = protocol + '//' + app.imagePath + '/Image';
		app.contentManagementUrl = app.url + '/ContentManagement/oldcontent';
		app.checkStatus = app.url + '/CheckStatus';
	} else {
		//setupCognitoEnvironment(app, true);
		setupCookieEnvironment();

		app.envName = 'Development';

		app.awsUrl = 'https://privateservice.payforward.com/v1';
		app.awsSearchUrl = 'https://privateservice.payforward.com/v1/search';
		app.url = 'http://localhost:1681';
		app.agapi = 'https://devagapi.payforward.com';
		app.authURL = app.url + '/Auth';
		app.userURL = app.url + '/User';
		app.consumerURL = app.url + '/Consumer';
		app.accountsURL = app.url + '/Accounts';
		app.merchantsURL = app.url + '/Merchant';
		app.merchantsSearchURL = app.awsSearchUrl + '/merchants';
		app.helperURL = app.url + '/Helper';
		app.lookupsURL = app.url + '/Lookups';
		app.searchURL = app.url + '/Search';
		app.searchSuggestionURL = app.awsSearchUrl + '/merchants/suggesters';
		app.searchCitySuggestionURL = app.awsSearchUrl + '/citystate';
		app.sharedURL = app.url + '/Shared';
		app.personalmessageURL = app.url + '/PersonalMessages';
		app.imageURL = app.url + '/Image';
		app.contentManagementUrl = app.url + '/ContentManagement/oldcontent';
		app.checkStatus = app.url + '/CheckStatus';
	}
	
	$('#environment').html(app.envName);

	app.globalEvents = _.extend({}, Backbone.Events);

	app.isMobile = function(){
		return device.mobile();
	};
	
	app.routeHistory = [];

	app.navigate = function(route, options){
		options = options || { trigger: true };
		
		if(/^https?:\/\//.test(route)){
			window.location.href = route;
		} else {
			Backbone.history.navigate(route, options);
		}
	};

	app.show = function (view, elementName) {
		if (this.currentView) {
			if (_.isFunction(this.currentView.cleanupEvents)) {
				this.currentView.cleanupEvents();
			}
			if (_.isFunction(this.currentView.cleanup)) {
				this.currentView.cleanup();
			}
			//this.currentView.close();
		}

		this.currentView = view;

		if (elementName) {
		   // this.currentView.delegateEvents();
			$(elementName).html(this.currentView.el);
		}
	};

	// Deprecate Soon - Replace with Modal
	app.popupbox = function(selector, options){
		options = options || {};
		options = _.extend({ opacity: 0.75}, options);

		if(selector){
			$(selector).colorbox(options);
		} else {
			$.colorbox(options);
		}
		$('#colorbox,#cboxOverlay,#cboxWrapper').css('z-index', '10000');
	};

	// Deprecate Soon - Replace with Modal
	app.popupboxresize = function(width, height, callback){
		
		if($('#cboxOverlay').is(':visible')){
			if($(window).width() < width){
				$.colorbox.resize({ width: '95%' });
			} else {
				$.colorbox.resize({ width: width + 'px' });
			}

			if($(window).height() < height){
				$.colorbox.resize({ height: '95%' });
			} else {
				$.colorbox.resize({ height: height + 'px' });
			}
		}

		if(callback){
			callback();
		}
	};

	// Deprecate Soon - Replace with Modal
	app.popupboxclose = function(callback){
		$.colorbox.close();
		if(callback){
			callback();
		}
	};

	// Deprecate Soon - Replace with Modal
	app.popupboxremove = function(){
		$.colorbox.remove();
	};

	app.viewLogin = function(goHome, callback, callbackoptions, options, cacheCallback){
		options = options || {};

		// comment

		if(pf.session.get('auth')){
			pf.session.logout();
		} else {
			var loginView = new LoginView({ goHome: goHome, callback: callback, callbackoptions: callbackoptions, options: options, cacheCallback: cacheCallback, elementName: '#mainRegion' });
			
			switch(options.isNotPopup){
				case true:
					pf.show(loginView);
					break;
				case false:
					pf.show(loginView);
					break;
				default:
					pf.show(loginView);
					break;
			};
		};
	};

	app.getCurrentRoute = function(){
		var path = Backbone.history.fragment;
		if(typeof path === 'undefined'){
			path = '';
		}
		return path;
	};
	
	app.utcfromnow = function(dt){
		if(moment(dt).isValid()){
			var nowDate = moment.utc();
			var dtValue = moment.utc(dt);
			var diff = nowDate.diff(dtValue, 'days');

			if(diff > 90){
				return moment(dt).format('M/D/YYYY');
			} else {
				return moment.utc(dt).from(Date.now());
			}
		}
		return '';
	};

	app.currentDTString = function(){
		return Date.now().toString();
	};

	app.require = function(viewpath, subNav, options,createNew, callback){
		if(pf.currentviewpath != viewpath || createNew == true){
			pf.currentviewpath = viewpath;
			callback();
		} else if(pf.currentView){
			// If displaySubnav is not present, callback or reload page (This occurance seems to be rare but is happening upon session expiration within Settings Sub Navigation.  A callback or refresh should solve this.  Let's find a better solution for this.)
			if(_.isFunction(pf.currentView.displaySubnav)){
				pf.currentView.displaySubnav(subNav, options);
			} else {
				if(_.isFunction(callback)){
					callback();
				} else {
					window.location.reload();
				}
			}
		}
		return false;
	};

	app.getContentFile = function(){
		if(!app.isLocalHost()){
			return app.contentFileName;
		} else {
			return {
				B: 'base.json',
				P: 'payforward_content.json'
				// P: 'bcbsalcsaalahealth_content.json'
				// P: 'bcbssc_content.json'
				// P: 'anthem_content.json'
				// P: 'bcbsla_content.json'
				// P: 'bluekc_content.json'
				// P: 'bcbsaz_content.json'
				// P: 'rxsavings_content.json'
				// P: 'bcbsal_content.json',
				// P: 'proteus_content.json',
				// P: 'uhp-csnp.json'
			};
		}
	};

	app.getContent = function(path, type, options){
		path = path || '';

		var current_property = app.content;

		// If the path is an object, that means we have most likely already obtained the current property
		if(_.isObject(path)){

			current_property = path;

		} else {

			var path_array = path.split('.');

			// Loop through properties until the desired one is found
			for(var i = 0; i < path_array.length; i++){
				
				current_property = current_property[path_array[i]];

				// Break loop if path leads to an undefined property - this is what used to break the site.
				if(current_property === undefined){
					console.warn('Invalid content path: "' + path + '"');
					break;
				}

			}

		}

		// If the property is an object, get the properties true value
		if(_.isObject(current_property) && !_.isArray(current_property)){

			if(current_property.hasOwnProperty('type')){
				
				if(current_property.hasOwnProperty('element')){
					
					if(current_property.element == 'svg'){
						current_property = enums.svg[current_property.property];
					}

					if(current_property.element == 'img'){
						current_property = '<img src="' + current_property.path + '/' + current_property.name + '" alt="" />';
					}

					// TODO: Create detection/creation of other html elements

				}

			}

		} else if(_.isArray(current_property)){

			// If the property is an array, find the desired object by an id passed within options

			if(_.isObject(options)){

				var item = current_property.filter(function(item){

					if(_.isArray(item.id)){

						var child_fields = item.fields.forEach(function(child_field){

							if(child_field.id == options.id){
								current_property = child_field;
							}

						});

					} else {
						
						if(item.id == options.id){
							return true;
						} else {
							return false;
						}

					}

				});

				if(item.length >= 1 && _.isArray(current_property)){

					current_property = item[0];

				} else if(_.isArray(current_property)){
					
					current_property = {};

				} else if(_.isObject(current_property)){}

			}

		}

		var content = current_property;

		// If a content type is specified, always return that type, even if it's content-free.
		if(type){

			if(type == 'string' && typeof content != 'string'){
				content = '';
			} else if(type == 'number' && typeof content != 'number'){
				content = 0;
			} else if(type == 'boolean' && typeof content != 'boolean'){
				content = false;
			} else if(type == 'array' && !Array.isArray(content)){
				content = [];
			} else if(type == 'object' && typeof content != 'object'){
				content = {};
			}

		}

		return content;
	};

	app.getFeature = function(feature_enum, options){

		if(!pf.features || !_.isArray(pf.features)){
			return {};
		}

		if(_.isObject(options)){

			var depth = options.depth || 1,
				feature_id_list = options.ids || [];
		
		}

		var feature = null;

		for(var f = 0; f < pf.features.length; f++){

			var item = pf.features[f];

			if(item.enum_value == feature_enum && _.isObject(options)){

				var list = item.features,
					current_depth = 0;

				if(_.isArray(list)){

					var first_feature = null;

					for(var i = 0; i < list.length; i++){
						var list_item = list[i];

						if(list_item.id == feature_id_list[0]){
							first_feature = list_item;
						}

					}

					if(depth == 1){

						if(first_feature){
							feature = first_feature;
						}

					} else if(first_feature && _.isArray(first_feature.features)) {

						var second_list = first_feature.features,
							second_feature = null;

						for(var i = 0; i < second_list.length; i++){
							var list_item = second_list[i];

							if(list_item.id == feature_id_list[1]){
								second_feature = list_item;
							}

						}

						if(depth == 2){

							if(second_feature){
								feature = second_feature;
							}

						}

					}

				}

			} else {

				if(item.enum_value == feature_enum){
					feature = item;
				}

			}

		}

		return feature;

	};

	app.getFeatureById = function(feature_id, options){

		if(!pf.features || !_.isArray(pf.features)){
			return {};
		}

		var feature = null,
			options = options || {};

		for(var f = 0; f < pf.features.length; f++){

			var item = pf.features[f];

			if(item.id == feature_id){

				if(options.depth == 1 && _.isNumber(options.set_id)){

					if(item.set_id == options.set_id){

						if(options.depth_id == 2){

							if(_.isArray(item.features)){

								for(var fp = 0; fp < item.features.length; fp++){

									var item_page = item.features[fp];

									if(item_page.id == options.id){
										feature = item_page;
									}

								}

							} else {
								console.warn('This feature does not have any nested features.', item);
							}

						} else {

							feature = item;

						}
						
					}

				} else if(options.depth == 2 && _.isNumber(options.id)){

					if(_.isArray(item.features)){

						for(var fp = 0; fp < item.features.length; fp++){

							var item_page = item.features[fp];

							if(_.isNumber(options.set_id)){

								if(item.set_id == options.set_id && item_page.id == options.id){
									feature = item_page;
								}

							} else {

								if(item_page.id == options.id){
									feature = item_page;
								}

							}

						}

					} else {
						console.warn('This feature does not have any nested features.', item);
					}

				} else {

					feature = item;

				}

			}

		}

		return feature;

	};

	app.getFeatureBySetId = function(feature_set_id, feature_id){

		if(!pf.features || !_.isArray(pf.features)){
			return {};
		}

		var feature = null;

		for(var f = 0; f < pf.features.length; f++){

			var item = pf.features[f];

			if(item.set_id == feature_set_id){

				if(_.isNumber(feature_id)){

					if(item.id == feature_id){
						feature = item;
					}

				} else {
					feature = item;
				}

			}

		}

		return feature;

	};

	app.initiateFbPixel = function(){
		
		if(!app.session.get('auth')){

			require(['views/shared/analytics/fb_pixel'], function(FbPixelComponent){

				app.fb_pixel = new FbPixelComponent();

			});
			
		}
		
	},

	app.on('initialize:before', function(){
		// console.log('App initialize before');
	});

	app.on('initialize:after', function(){

		app.session = new Session();

		if(Backbone.history){

			app.session.getAuth(function(){

				app.bootstrap();
			   
			});

		} else {

			app.navigate(this.getCurrentRoute());

		};
	});

	app.bootstrap = function(callback){

		// console.log('App initialize after');
		var spinner_opts = {
				lines    : 13,
				length   : 15,
				width    : 10,
				radius   : 25,
				corners  : 1,
				rotate   : 0,
				direction: 1,
				color    : '#000',
				speed    : 1,
				trail    : 60,
				shadow   : false,
				hwaccel  : false,
				className: 'spinner',
				zIndex   : 100
			},
			target = document.getElementById('Activity'),
			spinner = new Spinner(spinner_opts).spin(target);

		$('#Activity').attr('style', 'height: 500px;');
		$(spinner).attr('style', 'top: 50%; left: 50%;');

		getSiteContent(app.getContentFile(), Merge, function(resourceContent, features){
					
			if(typeof pfResponsive !== 'undefined'){

				if(pfResponsive){
					pf.responsive = true;
				} else {
					pf.responsive = false;
					$('html').removeClass('fluid');
				}

			} else if(typeof pfResponsive == 'undefined'){
				// If this variable doesn't exist then it is most likely mindex which is used for mobile apps
				// This means we must add the for responsiveness
				pf.responsive = true;
				$('html').addClass('fluid');
			}

			app.content = resourceContent;

			if(app.getContent('analytics.pixel')){
				app.initiateFbPixel();
			}

			app.features = features || [];

			app.controller.setupEnvironment();
			
			if(!Backbone.History.started){

				// Backbone.history.start({ pushState: true, root: '/' });
				Backbone.history.start();

			}

			// console.log('App after history start',app.session.get('auth'),app);
			
			if(app.session.get('auth')){

				// var currentRoute = that.getCurrentRoute();

				// if (!isEmpty(currentRoute)) {
				//     app.navigate(currentRoute);
				// } else {
				//     // app.navigate('home');
				// }

			}

			spinner.stop();

			$(target).remove();

			if(_.isFunction(callback)){
				callback();
			}
			
		});

	};

	app.on('start', function(){
		// console.log('App Start',pf.controller);

		// Add partner routes and designate the start/home view
		var pf_router = this.controller;
		// This works and overrides all defined routes in App.Router
		// var router = new pf_router();


	});

	app.addWrapper = function(tagName, tagID, Template){
		var wrapper = '<' + tagName + ' id="' + tagID + '">' + Template + '</' + tagName + '>';
		return _.template(wrapper);
	};

	app.CommentDisplayCount = 3;

	try {
		_.extend(Backbone.Validation.messages, {
			required: '{0} is required',
			min: '{0} should be at least {1} characters'
		});
	} catch(e){};

	return app;
});


